// user follows the default inbound call recording logic of company
export const INBOUND_CALL_RECORDING_MODE_DEFAULT = 1
// all inbound calls will be recorded
export const INBOUND_CALL_RECORDING_MODE_ALWAYS = 2
// all inbound calls won't be recorded
export const INBOUND_CALL_RECORDING_MODE_NEVER = 3
